<template>
    <el-dialog :title="titleVale" v-model="dialogVisible" width="30%" :before-close="handleClose">
        <el-form :model="form" :rules="rules" ref="ruleForm">
            <el-form-item label="标题:" prop="title" label-width="100px">
                <el-input v-model="form.title" autocomplete="off"></el-input>
            </el-form-item>
            <!-- <el-form-item label="所属用户:" prop="userName" label-width="100px">
                <el-input v-model="form.userName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="发布时间:" prop="addTime" label-width="100px">
                <el-date-picker
                    v-model="form.addTime"
                    type="datetime"
                    placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item> -->
            <el-form-item label="发布文本内容:" prop="textValue" label-width="100px">
                <el-input type="textarea" v-model="form.textValue" autocomplete="off"></el-input>
            </el-form-item>
            
            <el-form-item label="上传:" prop="shangchuan" label-width="100px" v-show="!fileShow ">
                <span @click="shangchuan">{{ this.tempFile }}</span>
            </el-form-item>
            <el-form-item v-show="fileShow" label="上传:" prop="shangchuan" label-width="100px">
                <input 
                ref="inputFile" 
                class="upload" 
                style="cursor: pointer;" 
                id="inputFile" 
                type="file" 
                @change="getFile($event)"
                @click="chufa"
                />
            </el-form-item>
            <el-form-item label="类型:" prop="type" label-width="100px">
                <el-select v-model="form.type" filterable placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <div class="buttom-box">
                <el-button type="primary" class="Tijiao" @click="submitForm('ruleForm')">提交</el-button>
                <el-button @click="handleClose">返回</el-button>
            </div>
        </el-form>

    </el-dialog>
</template>
<script>
import { noticeCreate,uploadImage,noticeUpdate} from '@/assets/api/schoollog'
// import { ElMessage } from 'element-plus'

export default {
    components: {
    },
    props: ['reviseItem'],
    data() {

        return {

            dialogVisible: true,
            title: '',
            form: {
                type: 11,
                userName: '',
                addTime: '',
                textValue: '',
                shangchuan: '',
                title: ''
            },
            cardid: "",
            schoolList: [],
            titleVale: '',
            options: [{
                value: 11,
                label: '新闻资讯'
            }, {
                value: 12,
                label: '安全教育'
            }],
            rules: {
                type: [
                    { required: true, message: '请选择类型', trigger: 'change' }
                ],
                userName: [
                    { required: true, message: '请选择所属用户', trigger: 'change' }
                ],
                addTime: [
                    { required: true, message: '发布时间', trigger: 'change' }
                ],
                textValue: [
                    { required: true, message: '发布文本内容', trigger: 'change' }
                ],
                title: [
                    { required: true, message: '标题', trigger: 'change' }
                ],
            },
            tempFile: '',
            picImage:'',
            fileShow: true
        }
    },
    created() {
        if ( JSON.stringify(this.reviseItem) != '{}' ) {
            this.titleVale = '修改信息'
            let data = JSON.parse(this.reviseItem.description)
            this.form.title = data.title
            this.form.textValue = data.content
            this.form.type = data.type
            // if (data.file != '' ) {
                this.picImage = data.file
                this.tempFile = data.file.slice(data.file.lastIndexOf('/') + 1);
            // }
            this.fileShow = false
            console.log(JSON.parse(this.reviseItem.description),this.tempFile);
        } else {
            this.titleVale = '新增信息'
        }
    },
    mounted() {

    },
    methods: {
        chufa () {
            console.log('测试4556');
        },
        shangchuan () {
            // this.$refs.inputFile.getFile($event)
            document.getElementById("inputFile").click();
            console.log(document.getElementById("inputFile"));
            // this.$refs.inputFile.click()
        },
        getFile(event) {
            this.fileShow = true    
            this.tempFile = event.target.files[0];
            let index = this.tempFile.name.lastIndexOf(".");
            let fileName = this.tempFile.name.substr(index + 1);
            var filetypes = [
                "jpg",
                "png",
                "gif",
                "jpeg",
                "doc",
                "ppt",
                "xls",
                "pdf",
                "docx",
                "xlsx",
            ];
            if (filetypes.includes(fileName)) {
                if (this.tempFile) {
                    let fileSize = this.tempFile.size / (1024 * 1024 * 60);
                    if (this.tempFile.name) {
                        let formData = new FormData();
                        console.log(formData, 8888888);
                        formData.append("file", this.tempFile);
                        console.log(this.tempFile, formData.getAll('file'),this.tempFile.name);
                 
                        uploadImage(formData,this.tempFile.name).then((res) => {
                            console.log(res);
                            this.picImage = res.data.data.picImage
                            // ElMessage({ message: '', type: 'success', })
                            this.$message({
                                message: '上传文件成功！',
                                type: 'success'
                            });
                        }).catch((err) => {
                            // console.log();
                            ElMessage.error("上传失败")
                        })


                    }
                }
            } else {
                ElMessage.error("请上传jpg,png,gif,jpeg,doc,ppt,xls,pdf,docx,xlsx格式的文件!")
            }
        },
        handleClose() {
            this.$emit('backClick')
        },
        submitForm(ruleForm) {
            this.$refs[ruleForm].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    this.addClick()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        addClick() {
            if ( JSON.stringify(this.reviseItem) != '{}' ) {
                let dataItem = JSON.parse(this.reviseItem.description)
                let params = {
                    file: this.picImage,
                    content: this.form.textValue,
                    title : this.form.title,
                    type : this.form.type,
                    id: this.reviseItem.id,
                    userId: JSON.parse(localStorage.getItem('user')).id,
                }
                noticeUpdate(params ).then((res) => {
                    console.log(res);
                    this.$message({
                        message: '修改信息成功！',
                        type: 'success'
                    });
                    this.handleClose()
                }).catch((err) => {
                    this.$message.error('修改信息失败');
                })
            } else {
                // if ( this.picImage == '' ) return this.$message.error('请上传文件');
                let params = {
                    file: this.picImage,
                    content: this.form.textValue,
                    title : this.form.title,
                    type : this.form.type,
                    userId: JSON.parse(localStorage.getItem('user')).id,
                }
                noticeCreate(params ).then((res) => {
                    console.log(res);
                    this.$message({
                                    message: '发布信息成功！',
                                    type: 'success'
                                });
                    this.handleClose()
                }).catch((err) => {
                    this.$message.error('发布信息失败');
                })
            }

        },
    }
}




</script>
<style  scoped lang="scss">
.Tijiao {
    // background-color: #1BC896;
}

/deep/ {
    .el-input--small .el-input__wrapper {
        height: 35px;
        line-height: 35px;
        text-align: center;
        width: 280px;
    }

    .el-input__inner {
        // width: 10px !important;
    }

    .buttom-box {
        // text-align: center;
        margin-left: 180px;

    }

    .el-form-item--small {
        width: 70% !important;
    }

    .el-button--small {
        width: 60px !important;
        height: 35px !important;
        // color: #1BC896;


    }

    .el-form-item--small .el-form-item__label {
        height: 35px;
        line-height: 35px;
    }
    .el-select--small .el-select__wrapper {
        height: 35px;
    }
}
</style>